module.exports = __webpack_public_path__ + "static/media/LogoSendero.f02edebc.png";